import React, { useState } from 'react'
import { Grid, Checkbox, Tooltip } from '@material-ui/core'
import { makeStyles, Theme } from '@material-ui/core/styles'
import { Formik, Field } from 'formik'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import StyledRadio from '@src/routes/Configurators/utils/ConfiguratorCustomRadioButton'
import RadioGroup from '@material-ui/core/RadioGroup'
import ValidationErrors from '../../../../validations/ValidationErrors'
import messages from '../../../../messages'
import { biTubeConfigContext } from '../../BiTube'
import { useFastduplexRuleValidationMutation } from '@src/mutations/ConfiguratorTubesMutation.generated'
import { FormattedMessage, useIntl } from 'react-intl'
import LiquidSelectAdapter from '@src/components/LiquidSelectAdapter'
import { BiTubeProduct, BitubeProperties } from '../../enum'
import ODYieldPopup from '../../../../../Configurators/components/PopUp/ODYieldPopup'
import InfoIcon from '@material-ui/icons/Info'
import clsx from 'clsx'
import { ConfiguratorValues } from '../../../../utils/constants'
import { ListError } from '../../Reducer'
import { checkValidKey } from '@src/routes/Configurators/utils/util'
import styles from '@src/routes/Configurators/utils/styles'

const useStyles = makeStyles((theme: Theme) => {
  return {
    contentWrapper: {
      backgroundColor: 'white',
      padding: theme.spacing(2, 5, 4),
      marginBottom: theme.spacing(5),
    },
    subHead: {
      fontSize: theme.typography.pxToRem(16),
      fontWeight: theme.typography.fontWeightMedium,
      margin: theme.spacing(2, 0),
      marginBottom: theme.spacing(4),
    },
    yieldLink: {
      marginLeft: theme.spacing(-0.5),
      marginTop: theme.spacing(-3),
    },
    titleText: {
      fontWeight: 'normal',
    },
    IconButton: {
      outlined: true,
      padding: theme.spacing(1),
      fontSize: theme.typography.pxToRem(14),
    },
    InfoPopup: {
      maxWidth: '250px',
      backgroundColor: 'white',
      position: 'relative',
      border: '1px solid white',
      boxShadow: '1px 1px 20px 1px lightgrey',
      padding: theme.spacing(5),
      fontSize: theme.typography.pxToRem(12),
      color: '#1b1b25',
      borderRadius: '2%',
      marginTop: theme.spacing(1),
    },
    arrow1: {
      minHeight: 10,
      minWidth: 10,
      color: 'white',
      backgroundColor: 'white',
      transform: 'translate(7%, -5%)rotate(-135deg)',
      top: '0',
      left: '50%',
      boxShadow: '1px 1px 1px 0px lightgrey',
    },

    label: {
      fontWeight: 'bold',
      fontSize: theme.typography.pxToRem(14),
      marginBottom: theme.spacing(2),
    },
    specificationsWrapper: {
      '& span.MuiFormControlLabel-label': {
        fontSize: theme.typography.pxToRem(14),
      },
    },
    InfoIcon: {
      position: 'relative',
      fontSize: theme.typography.pxToRem(16),
      top: theme.spacing(0.5),
      marginLeft: theme.spacing(1.5),
    },
    radio: {
      padding: theme.spacing(1),
    },
    fieldLabel: {
      marginTop: theme.spacing(5),
      '& label': {
        fontWeight: 'bold',
        fontSize: theme.typography.pxToRem(14),
      },
      '& .MuiInput-root': {
        width: '75%',
        '& .MuiSelect-root': {
          height: 35,
          lineHeight: '25px',
        },
      },
    },
    minYield: {
      textAlign: 'center',
      fontStyle: 'italic',
    },
    applyAll: {
      textAlign: 'right',
    },
    icon1: {
      borderRadius: '50%',
      width: 16,
      height: 16,
      boxShadow:
        'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
      backgroundColor: '#f5f8fa',
      backgroundImage:
        'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
      '$root.Mui-focusVisible &': {
        outline: '2px auto rgba(19,124,189,.6)',
        outlineOffset: 2,
      },
      'input:hover ~ &': {
        backgroundColor: '#ebf1f5',
      },
      'input:disabled ~ &': {
        boxShadow: 'none',
        background: 'rgba(206,217,224,.5)',
      },
    },
    checkedIcon: {
      backgroundColor: '#137cbd',
      backgroundImage:
        'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
      '&:before': {
        display: 'block',
        width: 16,
        height: 16,
        backgroundImage: `radial-gradient(${theme.palette.common.white},${theme.palette.common.white} 28%,transparent 32%)`,
        content: '""',
      },
      'input:hover ~ &': {
        backgroundColor: '#106ba3',
      },
    },
    nonRadioFastDuplex: {
      paddingTop: theme.spacing(1.5),
    },
    nonRadioLightcycle: {
      paddingTop: theme.spacing(3),
    },
    nonRadioDuplex: {
      paddingTop: theme.spacing(1),
    },
    disableConcentration: {
      color: theme.palette.text.disabled,
      '& .MuiTypography-colorPrimary': {
        color: theme.palette.text.disabled,
      },
      '&  .MuiSvgIcon-colorSecondary': {
        color: theme.palette.text.disabled,
      },
    },
    disableText: {
      backgroundColor: theme.palette.common.white,
      padding: theme.spacing(2, 5, 4),
      marginBottom: theme.spacing(5),
      color: theme.palette.text.disabled,
      '& .MuiTypography-colorPrimary': {
        color: theme.palette.text.disabled,
      },
      '&  .MuiSvgIcon-colorSecondary': {
        color: theme.palette.text.disabled,
      },
    },
    dropDownDisable: {
      '& .MuiSelect-selectMenu:focus': {
        borderColor: theme.palette.background.grey,
      },
    },
    dropDownEnable: {
      '& .MuiSelect-selectMenu:focus': {
        borderColor: theme.palette.vibrant.cyan,
      },
    },
    widthFillContent: {
      width: 'fit-content',
      display: 'inline-table',
    },
  }
})

const Specifications = (props) => {
  const classes = useStyles()
  const intl = useIntl()
  const GlobalCSS = styles()
  const { specificationsData, productDetails } = props
  const tubes =
    specificationsData.specifications !== undefined &&
    specificationsData.specifications.filter(
      (spec) => spec.categoryName === 'tube'
    )
  const tubeModifications =
    tubes !== undefined && tubes.map((tube) => tube.specificationModifications)
  const nonTubes =
    specificationsData.specifications !== undefined &&
    specificationsData.specifications.filter(
      (spec) => spec.categoryName !== 'tube'
    )

  let [errorValidation] = useState<string[]>([])
  const [specificationEnabled, setSpecificationEnabled] = useState(false)
  const { bitubeState, biTubeDispatch } = React.useContext(biTubeConfigContext)
  const [fastduplexRuleValidation] = useFastduplexRuleValidationMutation()
  const [specificationCategory, setSpecificationCategory] = useState<string>('')
  const { sessionData, currentOligoIndex, isSequenceValid, isAntiSeqValid } =
    bitubeState
  const [dialogOpen, setDialogOpen] = useState(false)
  const [applyAll, setApplyAll] = React.useState({
    checked: false,
  })
  const [noOfTubes, setNoOfTubes] = useState<string>('1')
  const [autoSelConcentration, setAutoSelConcentration] = useState<string>('')
  const [duplexConcentration, setDuplexConcentration] = useState<string>('')
  const [enableConcentration, setEnableConcentration] = useState<boolean>(false)
  const [isAutoConcentration, setAutoConcentration] = useState<boolean>(false)
  const [enablePurification, setEnablePurification] = useState<boolean>(false)
  const [sessionDataChanged, setSessionDataChanged] = useState<
    boolean | null | undefined
  >(false)
  const [totalValidationError, hasTotalValidationError] =
    useState<boolean>(false)
  const ruleValidation = async (obj) => {
    const response = await fastduplexRuleValidation({
      variables: { input: obj, productInput: productDetails },
    })
    const { data } = response
    if (data && !data.fastduplexRuleValidation.serverError) {
      biTubeDispatch({
        type: 'UPDATE_ERROR_RESPONSE',
        data: data.fastduplexRuleValidation,
      })
    } else {
      biTubeDispatch({
        type: 'SET_PAGE_ERROR',
        data: ConfiguratorValues.InternalServerError,
      })
      window.scrollTo(0, 0)
    }
  }

  const handleTubeDetails = (event) => {
    const { value } = event.target
    if (value) {
      sessionData[currentOligoIndex].tubes = value
      setNoOfTubes(value)
      if (currentOligoIndex !== 0) {
        //if anything changes in specification of items other than the first item, uncheck apply to all
        sessionData.forEach((data) => {
          data.applyToAll = false
        })
        setApplyAll({ ...applyAll, checked: false })
      }
      biTubeDispatch({
        type: 'UPDATE_INPUT',
        data: [...bitubeState.sessionData],
      })
      biTubeDispatch({
        type: 'UPDATE_ERROR_DATA',
        data: { ...bitubeState.errorData, tubes: value },
      })
      biTubeDispatch({ type: 'IS_CONFIRM_ORDER', data: false })
      biTubeDispatch({ type: 'SET_STEP_NO', data: 0 })
      setSessionDataChanged(true)
    }
  }

  React.useEffect(() => {
    if (bitubeState && bitubeState.seqLength !== 0 && sessionDataChanged) {
      ruleValidation(bitubeState.errorData)
      setSessionDataChanged(false)
    }
    // TODO: need a test before we refactor these dependencies
  }, [bitubeState.errorData])

  const onSpecificationChanged = (event, categoryName) => {
    const { name, value } = event.target
    setSpecificationEnabled(true)
    biTubeDispatch({ type: 'SPECIFICATION_TOTAL_VALIDATION', data: false })
    biTubeDispatch({ type: 'IS_CONFIRM_ORDER', data: false })
    biTubeDispatch({ type: 'SET_STEP_NO', data: 0 })
    if (currentOligoIndex !== 0) {
      //if anything changes in specification of items other than the first item, uncheck apply to all
      sessionData.forEach((data) => {
        data.applyToAll = false
      })
      setApplyAll({ ...applyAll, checked: false })
    }
    if (name === BitubeProperties.Amount) setEnablePurification(true)
    sessionData[currentOligoIndex][name] = value
    bitubeState.errorData[categoryName] = value
    if (name === BitubeProperties.Format) {
      if (value === BitubeProperties.DRY) {
        bitubeState.errorData.concentration = ''
        sessionData[currentOligoIndex].concentration = ''
        setEnableConcentration(false)
      } else {
        bitubeState.errorData.concentration = duplexConcentration
        sessionData[currentOligoIndex].concentration = duplexConcentration
        setEnableConcentration(true)
      }
    }
    biTubeDispatch({
      type: 'UPDATE_INPUT',
      data: [...bitubeState.sessionData],
    })
    if (name === BitubeProperties.Amount) {
      bitubeState.errorData.concentration = ''
    }
    biTubeDispatch({
      type: 'UPDATE_ERROR_DATA',
      data: { ...bitubeState.errorData },
    })
    setSpecificationCategory(categoryName)
    setAutoConcentration(false)
    setSessionDataChanged(true)
    return true
  }
  const validateOnRefesh = (name) => {
    let flag = false
    if (sessionData[currentOligoIndex].listError) {
      errorValidation = []
      sessionData[currentOligoIndex].listError.forEach((item: any) => {
        if (item.key === name) {
          errorValidation.push(item.value)
          flag = true
        }
        return flag
      })
    }
    return flag
  }
  const validateTotalData = (name) => {
    let flag = false
    if (
      bitubeState.totalValidation.length >=
      bitubeState.currentOligoIndex + 1
    ) {
      errorValidation = []
      const listErrors: any =
        bitubeState.totalValidation[bitubeState.currentOligoIndex].listErrors
      listErrors.forEach((item: any) => {
        if (item.key === name) {
          errorValidation.push(item.value)
          flag = true
        }
        if (flag) hasTotalValidationError(true)
        return flag
      })
    }
    return flag
  }

  const validateSpecificationData = (name) => {
    let flag = false
    if (bitubeState.seqLength === 0 || bitubeState.seqLength === undefined) {
      return false
    }
    if (
      name === BitubeProperties.Amount &&
      bitubeState.errorResponseJson.listConcentration?.length === 1 &&
      productDetails.productType === BiTubeProduct.FastDuplex &&
      autoSelConcentration !==
        bitubeState.errorResponseJson.listConcentration[0]
    ) {
      setAutoSelConcentration(
        bitubeState.errorResponseJson.listConcentration[0]
      )
    }

    if (Object.keys(bitubeState.errorResponseJson).length !== 0) {
      errorValidation = []
      bitubeState.errorResponseJson.listErrors.filter((item) => {
        if (item.key === name) {
          errorValidation.push(item.value)
          flag = true
        }
        return flag
      })
    } else {
      errorValidation = []
      return false
    }
    return flag
  }

  const validateData = (name) => {
    let flag = false
    if (bitubeState.seqLength === 0 || bitubeState.seqLength === undefined) {
      return false
    }
    if (
      name === BitubeProperties.Amount &&
      bitubeState.errorResponseJson.listConcentration?.length === 1 &&
      productDetails.productType === BiTubeProduct.FastDuplex &&
      autoSelConcentration !==
        bitubeState.errorResponseJson.listConcentration[0]
    ) {
      setAutoSelConcentration(
        bitubeState.errorResponseJson.listConcentration[0]
      )
    }

    if (Object.keys(bitubeState.errorResponseJson).length !== 0) {
      if (bitubeState.errorResponseJson.listErrors.length === 0) {
        errorValidation = []
        setSpecificationEnabled(false)
        hasTotalValidationError(false)
      }
      bitubeState.errorResponseJson.listErrors.filter((item) => {
        if (
          item.key === name &&
          item.value !== messages.CONF_REQUIRED_FIELD.defaultMessage
        ) {
          errorValidation.push(item.value)
          flag = true
        }
        return flag
      })
    } else {
      errorValidation = []
      return false
    }
    return flag
  }
  const validateOverrideData = (name) => {
    let flag = false

    const listerrors: any = bitubeState.errorResponseJson.listErrors
    if (listerrors) {
      errorValidation = []

      listerrors.forEach((item: any) => {
        if (item.key === name) {
          errorValidation.push(item.value)
          flag = true
        }
        return flag
      })
    }

    return flag
  }

  const callValidation = (name) => {
    if (sessionData[currentOligoIndex].isOverridden) {
      return false
    }
    if (
      bitubeState.specificationTotalValidation &&
      bitubeState.totalValidation.length
    ) {
      return validateTotalData(name)
    } else if (
      productDetails.isCSRSupervisor &&
      !sessionData[currentOligoIndex].isOverridden &&
      bitubeState.overiddenNumber !== 0
    ) {
      return validateOverrideData(name)
    } else if (bitubeState.errorOnPageRefresh) {
      return validateOnRefesh(name)
    } else if (specificationEnabled && totalValidationError) {
      return validateSpecificationData(name)
    }
    return false
  }
  const disableTubesDropdown = () => {
    if (sessionData[currentOligoIndex].isOverridden) {
      return false
    }
    return (
      bitubeState.seqLength === 0 ||
      bitubeState.seqLength === undefined ||
      bitubeState.antisenseSeqLength === 0 ||
      bitubeState.antisenseSeqLength === undefined ||
      !(isSequenceValid && isAntiSeqValid)
    )
  }

  const disablingRadioButton = (data, categoryName) => {
    const digiCheckFlag =
      categoryName === messages.CONF_PURIFICATION_TEXT.defaultMessage &&
      productDetails.isCSRSupervisor &&
      (sessionData[currentOligoIndex].fiveMod === '[DIG]' ||
        sessionData[currentOligoIndex].threeMod === '[DIG]' ||
        sessionData[currentOligoIndex].antisenceFiveMod === '[DIG]' ||
        sessionData[currentOligoIndex].antisenceThreeMod === '[DIG]')

    if (sessionData[currentOligoIndex].isOverridden && !digiCheckFlag) {
      return false
    }
    if (
      bitubeState.seqLength === 0 ||
      bitubeState.seqLength === undefined ||
      bitubeState.antisenseSeqLength === 0 ||
      bitubeState.antisenseSeqLength === undefined ||
      !(isSequenceValid && isAntiSeqValid) ||
      data === null
    ) {
      return true
    }

    if (categoryName === BitubeProperties.Purification && !enablePurification) {
      return true
    }
    if (Object.keys(bitubeState.errorResponseJson).length !== 0) {
      let list: any = []
      switch (categoryName) {
        case BitubeProperties.Amount: {
          list = bitubeState.errorResponseJson.listAmount

          break
        }
        case messages.CONF_CONCENTRATION_TEXT.defaultMessage: {
          list = bitubeState.errorResponseJson.listConcentration

          break
        }
        case messages.CONF_FORMAT_TEXT.defaultMessage: {
          list = bitubeState.errorResponseJson.listFormat

          break
        }
        case messages.CONF_PURIFICATION_TEXT.defaultMessage: {
          list = bitubeState.errorResponseJson.listPurification

          break
        }
        default:
          return false
      }
      if (list === null) {
        return true
      } else if (list.includes(data.value)) {
        return false
      }
      return true
    }
    return false
  }
  const checkConcentration = () => {
    return enableConcentration
  }

  const renderModifications = (modifications, categoryName) => {
    if (modifications.length === 1) {
      if (categoryName === BitubeProperties.Concentration) {
        setDuplexConcentration(modifications[0].value)
      } else {
        sessionData[currentOligoIndex][categoryName] = modifications[0].value
        bitubeState.errorData[categoryName] = modifications[0].value
      }
      if (categoryName === BitubeProperties.Concentration) {
        return (
          <div
            className={
              productDetails.productType === BiTubeProduct.LightCycler
                ? classes.nonRadioLightcycle
                : productDetails.productType === BiTubeProduct.FastDuplex
                  ? classes.nonRadioFastDuplex
                  : checkConcentration()
                    ? classes.nonRadioDuplex
                    : clsx(classes.disableConcentration, classes.nonRadioDuplex)
            }
          >
            <span>
              {intl.formatMessage(
                checkValidKey(
                  messages[modifications[0].displayName],
                  modifications[0].displayName
                )
              )}
            </span>
          </div>
        )
      } else {
        return (
          <div
            className={
              productDetails.productType === BiTubeProduct.LightCycler
                ? classes.nonRadioLightcycle
                : productDetails.productType === BiTubeProduct.FastDuplex
                  ? classes.nonRadioFastDuplex
                  : classes.nonRadioDuplex
            }
          >
            <span>
              {intl.formatMessage(
                checkValidKey(
                  messages[modifications[0].displayName],
                  modifications[0].displayName
                )
              )}
            </span>
          </div>
        )
      }
    } else {
      return modifications.map((modification, index: number) => {
        return (
          <FormControlLabel
            value={modification.value}
            control={<StyledRadio isConfiguratorsRedesign="true" />}
            className={classes.widthFillContent}
            label={intl.formatMessage(
              checkValidKey(
                messages[
                  modification.displayName.replace(/[^a-zA-Z0-9]/g, '_')
                ],
                modification.displayName.replace(/[^a-zA-Z0-9]/g, '_')
              )
            )}
            disabled={disablingRadioButton(modification, categoryName)}
            key={index}
          />
        )
      })
    }
  }

  const renderSpecifications = (specifications) => {
    return specifications.map((specification, index) => {
      if (specification.specificationModifications.length) {
        return (
          <Grid item sm={3} key={index}>
            <div className={classes.label}>
              {intl.formatMessage(
                checkValidKey(
                  messages[specification.categoryDisplayName],
                  specification.categoryDisplayName
                )
              )}
            </div>
            {productDetails.productType === BiTubeProduct.LightCycler ? (
              <Grid>
                {specification.categoryName === BitubeProperties.Amount ? (
                  <div className={classes.yieldLink}>
                    <ODYieldPopup
                      isValid={disableTubesDropdown()}
                      dialogOpen={dialogOpen}
                      setDialogOpen={setDialogOpen}
                      productName={productDetails.productType}
                    />
                  </div>
                ) : (
                  ''
                )}
              </Grid>
            ) : (
              ''
            )}
            <div>
              <RadioGroup
                aria-label="scale"
                name={specification.categoryName}
                value={
                  bitubeState.sessionData[bitubeState.currentOligoIndex][
                    specification.categoryName
                  ]
                }
                onChange={(event) =>
                  onSpecificationChanged(event, specification.categoryName)
                }
              >
                {renderModifications(
                  specification.specificationModifications,
                  specification.categoryName
                )}
              </RadioGroup>
            </div>
            {callValidation(specification.categoryName) ? (
              <div>
                <ValidationErrors errors={errorValidation} />
              </div>
            ) : (
              ''
            )}
          </Grid>
        )
      } else {
        return ''
      }
    })
  }

  const tubeDropDownList = (listTubes) => {
    const list = [{ label: '', value: '' }]
    if (listTubes && listTubes.length > 0) {
      list.length = 0
      bitubeState.errorResponseJson.listTubes.forEach((tube) => {
        list.push({ label: tube, value: tube })
      })
    } else {
      tubeModifications[0].forEach((tube) => {
        list.push({ label: tube.name, value: tube.value })
      })
    }
    return list
  }
  const renderTubes = () => {
    if (
      productDetails.productType === BiTubeProduct.Duplex ||
      productDetails.productType === BiTubeProduct.LightCycler ||
      productDetails.productType === BiTubeProduct.mirna
    ) {
      return (
        <Grid container className={classes.fieldLabel} alignItems="flex-end">
          <Grid item sm={2}>
            <div className={classes.label}>
              {<FormattedMessage {...messages.CONF_NO_OF_TUBES} />}
              <span className={classes.titleText}>
                <Tooltip
                  title={
                    <FormattedMessage {...messages.CONF_NO_TUBES_POPUP_MSG} />
                  }
                  classes={{
                    tooltip: classes.InfoPopup,
                    arrow: classes.arrow1,
                  }}
                  arrow
                  placement="bottom-end"
                  disableHoverListener={disableTubesDropdown()}
                >
                  <InfoIcon
                    aria-label="info"
                    className={classes.InfoIcon}
                    color="primary"
                  ></InfoIcon>
                </Tooltip>
              </span>
            </div>

            <Field
              name="tubes"
              component={LiquidSelectAdapter}
              value={noOfTubes}
              options={tubeDropDownList(
                bitubeState.errorResponseJson.listTubes
              )}
              onClick={handleTubeDetails}
              onBlur={(event) => {
                if (!event) return
              }}
              disabled={disableTubesDropdown()}
              className={
                disableTubesDropdown()
                  ? classes.dropDownDisable
                  : classes.dropDownEnable
              }
              filled
            />
          </Grid>
        </Grid>
      )
    } else
      return (
        <Grid container className={classes.fieldLabel} alignItems="flex-end">
          <Grid item sm={2}>
            <div className={classes.label}>
              {<FormattedMessage {...messages.CONF_NO_OF_TUBES} />}
            </div>
            <div>
              <span>{tubeModifications[0][0].name}</span>
            </div>
          </Grid>
        </Grid>
      )
  }

  const removeError = (key) => {
    // if the seq error is removed, remove it from the list array
    const error: ListError[] = []
    sessionData[currentOligoIndex].listError.forEach((err) => {
      if (err.key === key) {
        error.push(err)
      }
    })
    const array = sessionData[currentOligoIndex].listError
    error.forEach((e) => {
      const index = array.indexOf(e)
      if (index !== -1) {
        array.splice(index, 1)
      }
    })
  }

  React.useEffect(() => {
    if (specificationCategory !== '' && !isAutoConcentration) {
      validateData(specificationCategory)
      const error: any[] = []
      let hasAmountErr = false
      let hasPurifiErr = false
      let hasFormatErr = false
      let hasConcentratErr = false
      if (bitubeState.errorResponseJson.listErrors) {
        bitubeState.errorResponseJson.listErrors.forEach((item) => {
          delete item.__typename
          if (
            item?.key === BitubeProperties.Amount &&
            item.value !== intl.formatMessage(messages.CONF_REQUIRED_FIELD)
          ) {
            error.push(item)
          }
          switch (item?.key) {
            case BitubeProperties.Amount: {
              hasAmountErr = true
              break
            }
            case BitubeProperties.Purification: {
              hasPurifiErr = true
              break
            }
            case BitubeProperties.Format: {
              hasFormatErr = true
              break
            }
            case BitubeProperties.Concentration: {
              hasConcentratErr = true
              break
            }
            // no default
          }
        })
        if (error.length) {
          sessionData[currentOligoIndex].listError = error
        }
        if (!hasAmountErr) {
          removeError(BitubeProperties.Amount)
        }
        if (!hasFormatErr) {
          removeError(BitubeProperties.Format)
        }
        if (!hasPurifiErr) {
          removeError(BitubeProperties.Purification)
        }
        if (!hasConcentratErr) {
          removeError(BitubeProperties.Concentration)
        }
      }
      biTubeDispatch({
        type: 'UPDATE_INPUT',
        data: [...bitubeState.sessionData],
      })
    }
    // TODO: need a test before we refactor these dependencies
  }, [bitubeState.errorResponseJson])

  React.useEffect(() => {
    setAutoSelConcentration('')
    setApplyAll({ ...applyAll, checked: false })
    if (!sessionData[bitubeState.currentOligoIndex].amount)
      setEnablePurification(false)
    // TODO: need a test before we refactor these dependencies
  }, [bitubeState.OligoIndex, bitubeState.deleteLastOligo])

  React.useEffect(() => {
    if (autoSelConcentration !== '') {
      sessionData[currentOligoIndex].concentration = autoSelConcentration
      biTubeDispatch({
        type: 'UPDATE_INPUT',
        data: [...bitubeState.sessionData],
      })
      setAutoConcentration(true)
    }
    // TODO: need a test before we refactor these dependencies
  }, [autoSelConcentration])

  const handleApplyToAll = (isChecked) => {
    setApplyAll({ ...applyAll, checked: isChecked })
    // now set epmty data here

    sessionData[currentOligoIndex].applyToAll = isChecked

    sessionData.forEach((data) => {
      data.amount = sessionData[0].amount
      data.purification = sessionData[0].purification
      data.concentration = sessionData[0].concentration
      data.format = sessionData[0].format
      data.tubes = sessionData[0].tubes
      if (!isChecked) {
        data.applyToAll = isChecked
      }
    })
    biTubeDispatch({
      type: 'UPDATE_INPUT',
      data: [...bitubeState.sessionData],
    })
  }

  React.useEffect(() => {
    if (
      bitubeState.isPageLoad === 3 &&
      sessionData !== null &&
      sessionData.length !== 0 &&
      sessionData[bitubeState.currentOligoIndex] !== null &&
      Object.keys(sessionData[bitubeState.currentOligoIndex]).length !== 0
    ) {
      if (
        sessionData[bitubeState.currentOligoIndex].format ===
        BitubeProperties.LIQUID
      ) {
        setEnableConcentration(true)
      } else {
        setEnableConcentration(false)
      }
      if (
        sessionData[0].applyToAll !== null &&
        sessionData[0].applyToAll !== undefined
      ) {
        setApplyAll({ ...applyAll, checked: sessionData[0].applyToAll })
        if (sessionData[0].applyToAll) {
          handleApplyToAll(sessionData[0].applyToAll)
        }
      }
      const tubes: any = sessionData[bitubeState.currentOligoIndex].tubes
      setNoOfTubes(tubes)
      if (sessionData[bitubeState.currentOligoIndex].amount)
        setEnablePurification(true)
      biTubeDispatch({
        type: 'UPDATE_ERROR_DATA',
        data: {
          ...bitubeState.errorData,
          amount: sessionData[bitubeState.currentOligoIndex].amount,
          purification: sessionData[bitubeState.currentOligoIndex].purification,
          format: sessionData[bitubeState.currentOligoIndex].format,
          concentration:
            sessionData[bitubeState.currentOligoIndex].concentration,
          tubes: sessionData[bitubeState.currentOligoIndex].tubes,
        },
      })
    }
    // TODO: need a test before we refactor these dependencies
  }, [bitubeState.isPageLoad, bitubeState.currentOligoIndex])

  return (
    <div
      className={
        disableTubesDropdown() ? classes.disableText : classes.contentWrapper
      }
    >
      <Grid container>
        <Grid item sm={6}>
          <h4 className={classes.subHead}>
            <FormattedMessage {...messages.CONF_SPECIFICATIONS} />
          </h4>
        </Grid>
        {currentOligoIndex === 0 ? (
          <Grid
            item
            sm={6}
            className={clsx(classes.applyAll, GlobalCSS.checkedIcon)}
          >
            <Checkbox
              checked={applyAll.checked}
              color="primary"
              onChange={(e) => {
                handleApplyToAll(e.target.checked)
                biTubeDispatch({ type: 'IS_CONFIRM_ORDER', data: false })
                biTubeDispatch({ type: 'SET_STEP_NO', data: 0 })
              }}
              disabled={disableTubesDropdown()}
            />{' '}
            <span>
              <FormattedMessage {...messages.CONF_APPLY_TO_ALL} />
            </span>
          </Grid>
        ) : (
          ''
        )}
      </Grid>
      <Formik
        initialValues={{ oligoTubes: 1 }}
        onSubmit={(values, actions) => {
          setTimeout(() => {
            actions.setSubmitting(false)
          }, 1000)
        }}
      >
        {() => (
          <>
            <Grid container className={classes.specificationsWrapper}>
              {renderSpecifications(nonTubes)}
            </Grid>
            {renderTubes()}
          </>
        )}
      </Formik>
    </div>
  )
}

export default Specifications
